import { call, put, takeEvery } from "redux-saga/effects";
import { dangKyApi } from "../../../api/dang-ky-ho/dangKyApi";
import { IDanhSachLopTinChiAddOrUpdateRequest } from "../../../model/request/dang-ky-ho/IDanhSachLopTinChiAddOrUpdateRequest";
import { ILopTinChiSelectDangKyBySinhVienRequest } from "../../../model/request/dang-ky-ho/ILopTinChiSelectDangKyBySinhVienRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eDangKyHoActionIds, IDangKyHoActionTypes, IDangKyHocSinhVienActionTyes } from "../../action-types/dang-ky-ho/IDangKyHoActionTypes";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.dangKyHoActions;
export function* dangKyHoSaga(): any {
    yield takeEvery(eDangKyHoActionIds.LOAD_LOPTINCHI_SINHVIEN_START, loadLopTinChiWorker);
    yield takeEvery(eDangKyHoActionIds.LOAD_DANGKY_SINHVIEN_START, loadDangKyWorker);
    yield takeEvery(eDangKyHoActionIds.DANGKY_SINHVIEN_START, dangKyWorker);
    yield takeEvery(eDangKyHoActionIds.HUY_DANGKY_SINHVIEN_START, huyDangKyWorker);
    yield takeEvery(eDangKyHoActionIds.RUT_HOCPHAN_SINHVIEN_START, rutHocPhanWorker);
    yield takeEvery(eDangKyHoActionIds.CAPNHAT_CHUYENNGANH2_START, capNhatChuyenNganh2Worker);
}

function* loadLopTinChiWorker(action: IDangKyHoActionTypes): any {
    const payload = action.payload as IDangKyHocSinhVienActionTyes<ILopTinChiSelectDangKyBySinhVienRequest>;
    const res: IBaseRespone = yield call(dangKyApi.Select, payload.data);
    if (res.is_success) {
        yield put(mainAction.LOAD_LOPTINCHI_SINHVIEN_SUCCESS({
            data: res.data,
            id: payload.id
        }));
    } else {
        yield put(mainAction.LOAD_LOPTINCHI_SINHVIEN_ERROR({
            id: payload.id,
            data: res.message ?? "Có lỗi"
        }));
    }
}

function* loadDangKyWorker(action: IDangKyHoActionTypes): any {
    const payload = action.payload as IDangKyHocSinhVienActionTyes<ILopTinChiSelectDangKyBySinhVienRequest>;
    const res: IBaseRespone = yield call(dangKyApi.SelectKetQua, payload.data);
    if (res.is_success) {
        yield put(mainAction.LOAD_DANGKY_SINHVIEN_SUCCESS({
            data: res.data,
            id: payload.id
        }));
    } else {
        yield put(mainAction.LOAD_DANGKY_SINHVIEN_ERROR({
            id: payload.id,
            data: res.message ?? "Có lỗi"
        }));
    }
}


function* dangKyWorker(action: IDangKyHoActionTypes): any {
    const payload = action.payload as IDangKyHocSinhVienActionTyes<IDanhSachLopTinChiAddOrUpdateRequest>;
    const res: IBaseRespone = yield call(dangKyApi.DangKy, payload.data);
    if (res.is_success) {
        yield put(mainAction.DANGKY_SINHVIEN_SUCCESS({
            data: res.data,
            id: payload.id
        }));
    } else {
        yield put(mainAction.DANGKY_SINHVIEN_ERROR({
            id: payload.id,
            data: res.message ?? "Có lỗi"
        }));
    }
}

function* huyDangKyWorker(action: IDangKyHoActionTypes): any {
    const payload = action.payload as IDangKyHocSinhVienActionTyes<number>;
    const res: IBaseRespone = yield call(dangKyApi.HuyDangKy, payload.data);
    if (res.is_success) {
        yield put(mainAction.HUY_DANGKY_SINHVIEN_SUCCESS({
            data: payload.data,
            id: payload.id
        }));
    } else {
        yield put(mainAction.HUY_DANGKY_SINHVIEN_ERROR({
            id: payload.id,
            data: res.message ?? "Có lỗi"
        }));
    }
}

function* rutHocPhanWorker(action: IDangKyHoActionTypes): any {
    const payload = action.payload as IDangKyHocSinhVienActionTyes<number>;
    const res: IBaseRespone = yield call(dangKyApi.RutBotHocPhan, payload.data);
    if (res.is_success) {
        yield put(mainAction.RUT_HOCPHAN_SINHVIEN_SUCCESS({
            data: payload.data,
            id: payload.id
        }));
    } else {
        yield put(mainAction.RUT_HOCPHAN_SINHVIEN_ERROR({
            id: payload.id,
            data: res.message ?? "Có lỗi"
        }));
    }
}

function* capNhatChuyenNganh2Worker(action: IDangKyHoActionTypes): any {
    const payload = action.payload as IDangKyHocSinhVienActionTyes<{ id: number; chuyen_nganh2: boolean }>;
    const res: IBaseRespone = yield call(dangKyApi.CapNhatChuyenNganh2, payload.data.id, payload.data.chuyen_nganh2);
    if (res.is_success) {
        yield put(mainAction.CAPNHAT_CHUYENNGANH2_SUCCESS({
            data: payload.data,
            id: payload.id
        }));
    } else {
        yield put(mainAction.CAPNHAT_CHUYENNGANH2_ERROR({
            id: payload.id,
            data: res.message ?? "Có lỗi"
        }));
    }
}
